export default {
  read: {
    title: "Services",
    subtitle:
      "Fill in all the details of your services and show your work on your website.",
    createNewBtn: "New item",
    see: "See services",
    details: "See calendar",
    modal: {
      header: {
        title: "Design",
        section: "Services"
      },
      sections: {
        title: {
          separator: "Title",
          titleLabel: "Title",
          subtitleLabel: "Subtitle"
        },
        background: {
          separator: "Background",
          colorLabel: "Color"
        }
      },
      save: "Save"
    }
  },
  create: {
    title: "New service",
    subtitle:
      "Rellena todos los datos de tus servicios y muestra tu trabajo en tu web.",
    form: {
      title: "Servicios que ofreces",
      subtitle: "Define los servicios que marcan a tu empresa.",
      image: "Icono",
      name: "Nombre del servicio",
      description: {
        title: "Descripción",
        subtitle:
          "La decripción se incluirá justo debajo del título que cada servicio. Máx 200 carácteres"
      }
    },
    price: {
      title: "Pago por adelantado",
      label: "Precio"
    },
    bookings: {
      title: "Reservas online",
      label: "Link a Calendy / Google Calendar"
    },
    notifications: {
      created: "Servicio creado con éxito",
      edited: "Servicio actualizado con éxito",
      removed: "Servicio eliminado con éxito"
    },
    highlight: {
      label: "Destacar evento",
      under: "Servicio destacado",
      cancel: "Cancel"
    }
  }
};
